// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"126":"[auth]","285":"[Home]","631":"[profile]"}[chunkId] || chunkId) + "." + {"126":"fd4456ad","285":"a4783be9","387":"f3ce771a","631":"5cda11b2","657":"2a903b0a","787":"4a21b8e5","935":"087266de","996":"736f9905"}[chunkId] + ".chunk.js";
};